import React from "react";

/** Figma arrow-down-to-line — outer 16×16, leaf inset 12.5% / 20.83% (I2181:7659;1590:9196) */
const ArrowDownToLineIcon = ({ className, ...rest }: React.SVGProps<SVGSVGElement>) => {
    return (
        <span className="relative inline-block size-4 shrink-0 overflow-hidden" aria-hidden>
            <span className="absolute inset-[12.5%_20.83%]">
                <span className="absolute inset-[-6%]">
                    <svg
                        className={className ?? "block size-full"}
                        viewBox="0 0 10 12.6667"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        {...rest}
                    >
                        <path
                            d="M5 9.66667V0.333333M9 5.66667L5 9.66667L1 5.66667M9.66667 12.3333H0.333333"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </span>
            </span>
        </span>
    );
};

export default ArrowDownToLineIcon;
